import { Tabs } from '@ygtechnologies/rubus-ui';
import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import OutgoingEmailsTable from './OutgoingEmailsTable';
import OutgoingSmsTable from './OutgoingSmsTable';
import ReceivedEmailsTable from './ReceivedEmailsTable';
import CommunicoreSummary from './CommunicoreSummary';

export type CommunicoreTab = 'outgoing-emails' | 'outgoing-sms' | 'received-emails';

interface TabSettings {
    id: CommunicoreTab;
    name: string;
    component: React.ComponentType;
}

const tabs: TabSettings[] = [
    {
        id: 'outgoing-emails',
        name: 'Outgoing Emails',
        component: OutgoingEmailsTable,
    },
    {
        id: 'outgoing-sms',
        name: 'Outgoing SMS',
        component: OutgoingSmsTable,
    },
    {
        id: 'received-emails',
        name: 'Received Emails',
        component: ReceivedEmailsTable,
    },
];

const CommunicorePage: React.FC = () => {
    const { tab } = useParams<{ tab?: CommunicoreTab }>();
    const activeTab = tab || 'outgoing-emails';
    const activeTabConfig = tabs.find((x) => x.id === activeTab);
    const ActiveComponent = activeTabConfig?.component;

    return (
        <div>
            <h2>Communicore</h2>
            <CommunicoreSummary />
            <Tabs.Container activeId={activeTab} variant="underline">
                {tabs.map((tabConfig) => (
                    <Tabs.Tab
                        key={tabConfig.id}
                        id={tabConfig.id}
                        as={Link}
                        to={`/communicore/${tabConfig.id}`}
                        label={tabConfig.name}
                    />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{ActiveComponent && <ActiveComponent />}</div>
                </Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default CommunicorePage;
